export enum OwnerTypeEnum {
  current = 'current',
  proposed = 'proposed',
  outgoing = 'outgoing'
}
